import { render, staticRenderFns } from "./Joinkol.vue?vue&type=template&id=2a9de3d8"
import script from "./Joinkol.vue?vue&type=script&lang=js"
export * from "./Joinkol.vue?vue&type=script&lang=js"
import style0 from "./Joinkol.vue?vue&type=style&index=0&id=2a9de3d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports